import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export enum PermissionGroupEnum {
  ADMIN = 'ADMIN',
  ACCOUNTING = 'ACCOUNTING',
  READONLY = 'READONLY',
  SUPPORT = 'SUPPORT',
  FLEET_MANAGER = 'FLEET_MANAGER',
  RETURNS = 'RETURNS',
  DAMAGES = 'DAMAGES',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  DEPO = 'DEPO',
  DRIVERS = 'DRIVERS',
  SECURITY = 'SECURITY',
  SALES = 'SALES'
}

export class IPostUserOperationPermissionsBodyDto {
  userId: number;
  operationId?: number;
  permissionGroup: PermissionGroupEnum;
}

export class IPatchUserOperationsPermissionsBodyDto {
  operationId?: number;
  permissionGroup: PermissionGroupEnum;
}

export class UserOperationsPermission {
  id: number;
  userId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IUserOperationsPermissionResponse {
  @Type(() => UserOperationsPermission)
  result: UserOperationsPermission;
}

export class IUserOperationsPermissionListResponse extends IPagination {
  @Type(() => UserOperationsPermission)
  results: UserOperationsPermission[];
}

export class IUserOperationspermissionsQueryDto extends IQueryPaginationDto {
  userId?: string;
}
